import { gaEvent, slugify } from 'src/utils'

export type PaymentLinkCallbackEventNames =
  | 'callback_criar_link_pagamento_sucesso'
  | 'callback_link_pagamento_sucesso'
  | 'callback_link_pagamento_erro'
export type PaymentLinkCallbackOptions =
  //Callback criação do link de pagamento
  'criar-link-pix' | 'criar-link-cartao-de-credito' | 'pix' | 'cartao'

export type PaymentLinkCallbackEventParams = {
  name: PaymentLinkCallbackEventNames
  interaction: PaymentLinkCallbackOptions
  errorMessage?: string
}

/**
 * Eventos de callback mapeados do link de pagamento.
 * Obs: Novo formato para o GA4.
 *
 * [TARGET]: Qualquer evento de interação, como click, callback ou input.
 *
 * [CONTEXTO]: No link de pagamento, qualquer serviço ou ação que retorne uma resposta e que seja relevante para o acompanhamento de eventos.
 *
 * [REGRAS]: n/a
 */
export function paymentLinkCallbackEvent({
  name,
  interaction,
  errorMessage,
}: PaymentLinkCallbackEventParams) {
  gaEvent({
    event: 'analytics-event',
    event_parameters: {
      event_name: name,
      cd_interaction_detail: interaction,
      cd_error_message: errorMessage ? slugify(String(errorMessage)) : undefined,
    },
  })
}
